import openPersistentTaskPaneAddinCommand from '../../entryPointOperations/openPersistentTaskPaneAddinCommand';
import { getMode } from '../NavigationConditions';
import { setPreviousNavigationState } from '../PreviousNavigationState';
import { TaskPaneType, terminateTaskPaneAddinCommand } from 'owa-addins-store';

export default function reOpenAddinNavigationOperation(hostItemIndex: string) {
    terminateTaskPaneAddinCommand(TaskPaneType.Persistent);
    openPersistentTaskPaneAddinCommand(hostItemIndex);

    setPreviousNavigationState({
        hostItemIndex: hostItemIndex,
        mode: getMode(hostItemIndex),
        isNullSent: false,
    });
}
